import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { ApproveModalContent } from "../../../components/ApproveModalContent/ApproveModalContent";
import Modal from "../../../components/Modal/Modal";
import TransactionResult from "../../../components/TransactionResult/TransactionResult";
import useOpenUniversalLink from "../../../hooks/methods/useOpenUniversalLink";
import useLaunchSale from "../../../hooks/useLaunchSale";
import { useUserCartStore } from "../helpers/useUserCartStore";
import { CartModalType } from "../store/UserCartStore";

export const CartFlowModals: React.FC = observer(() => {
  const cartStore = useUserCartStore();
  const { openUniversalLink } = useOpenUniversalLink();
  const { purchaseCartItems } = useLaunchSale();
  const navigate = useNavigate();

  const renderCurrentModal = () => {
    switch (cartStore.currentModal) {
      case CartModalType.transactionPending:
        return (
          <ApproveModalContent
            title={
              cartStore.didUserRejectsWalletAction
                ? "Checking transaction"
                : "Go to your wallet"
            }
            subtitle={
              cartStore.didUserRejectsWalletAction
                ? "We are checking your transactions. It may take some time"
                : "You'll be asked to review and confirm this cancellation from your wallet"
            }
            isButtonDisabled={!cartStore.didUserRejectsWalletAction}
            primaryAction={async () => {
              await purchaseCartItems(cartStore.cart);
              cartStore.resetCart();
              cartStore.setModalVisibility(false);
              navigate(`/cart/congrats`);
            }}
            secondaryAction={openUniversalLink}
          />
        );
      case CartModalType.transactionError:
        return (
          <TransactionResult
            status="error"
            secondaryAction={() => cartStore.setModalVisibility(false)}
          />
        );
      case CartModalType.transactionSuccess:
        return (
          <TransactionResult
            status="success"
            title="Your sales was successfully purchased"
            buttonTitle="Close"
            secondaryAction={() => cartStore.setModalVisibility(false)}
          />
        );
    }
  };

  return (
    <Modal
      isOpened={cartStore.isModalVisible}
      onClose={() => cartStore.setModalVisibility(false)}
      blockStyles={{ maxWidth: "400px" }}
    >
      {renderCurrentModal()}
    </Modal>
  );
});
